import type React from 'react';
import type { MouseEvent } from 'react';

import { Button } from '@cobliteam/ui/components';
import type { TablePaginationActionsProps } from '@material-ui/core/TablePagination/TablePaginationActions';
import { css } from 'emotion';

import Icon from '@cobliteam/ui/icons';

const wrapper = css`
  display: flex;
  margin-left: 20px;
  gap: 4px;
`;

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const TablePaginationActions: React.FC<TablePaginationActionsProps> = ({ count, page, rowsPerPage, onPageChange }) => {
  const handleFirstPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => onPageChange(event, 0);

  const handleBackButtonClick = (event: MouseEvent<HTMLButtonElement>) => onPageChange(event, page - 1);

  const handleNextButtonClick = (event: MouseEvent<HTMLButtonElement>) => onPageChange(event, page + 1);

  const handleLastPageButtonClick = (event: MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={wrapper}>
      <Button variant='outlined' size='sm' icon={<Icon name='chevron-first' />} onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='Primeira página' />
      <Button variant='outlined' size='sm' icon={<Icon name='chevron-left' />} onClick={handleBackButtonClick} disabled={page === 0} aria-label='Página anterior' />
      <Button
        variant='outlined'
        size='sm'
        icon={<Icon name='chevron-right' />}
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='Próxima página'
      />
      <Button
        variant='outlined'
        size='sm'
        icon={<Icon name='chevron-last' />}
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label='Última página'
      />
    </div>
  );
};
